import {Box, TextField} from '@mui/material';
import {useTranslation} from "react-i18next";
import {TemplateData} from "../../pages/app/types.ts";

interface NameStepProps {
    template: TemplateData;
    setTemplate: (template: TemplateData) => void;
}

const NameStep = ({ template, setTemplate }: NameStepProps) => {
    const {t} = useTranslation();

    return (
        <Box sx={{ flex: 1, overflow: 'auto', p: 2 }}>
            <TextField
                fullWidth
                required={true}
                label={t('stepper.step.name.placeholder')}
                variant="outlined"
                value={template.name}
                onChange={(e) => setTemplate({...template, name: e.target.value})}
            />
        </Box>
    );
};

export default NameStep;
